import * as THREE from "three";

/*
 * Registre des positions RÉELLEMENT rendues des avatars, indexé par player.id.
 *
 * Pourquoi : `player.position` est la position CIBLE envoyée par le serveur.
 * PlayerCharacter ne s'y rend pas instantanément, il la rejoint via un ressort
 * amorti (SPRING_STIFFNESS / SPRING_DAMPING). Tout ce qui doit être visuellement
 * ACCROCHÉ à l'avatar — le fil des bulles de question — doit donc lire la position
 * rendue, pas la cible : sinon l'attache part en avant, vers l'endroit où l'avatar
 * va arriver, et le lien avec le personnage se perd.
 *
 * SideCamera résout le même problème en rejouant le ressort avec les mêmes
 * constantes. Ça suffit pour une caméra, pas pour un point d'attache : la moindre
 * dérive se voit. D'où ce registre, qui donne la position exacte.
 */
const anchors = new Map<string, THREE.Vector3>();

export function setAvatarAnchor(playerId: string, position: THREE.Vector3) {
  const existing = anchors.get(playerId);
  if (existing) existing.copy(position);
  else anchors.set(playerId, position.clone());
}

export function getAvatarAnchor(playerId: string): THREE.Vector3 | undefined {
  return anchors.get(playerId);
}

export function clearAvatarAnchor(playerId: string) {
  anchors.delete(playerId);
}
